var jQuery_vital = $.noConflict(true);